<template>
	<div class="aside-wrap">
		<div class="aside-title">
			<div class="title-l">
				<!-- <div class="title-icon">
					<img src="@/assets/circle_icon.png" />
				</div> -->
				<h3>推荐圈子</h3>
			</div>
		</div>
		<div class="aside-content">
			<ul>
				<li v-for="item in dataList" :key="item.id" @click="toDetail(item.id)">
					<img v-if="item.icon" :src="item.icon"/>
					<img v-else src="@/assets/default-img.png"/>
					<span>{{item.circleName}}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'AsideCircle',
		components: {
		},
		data(){
			return {
				pageNum: 1,
				pageSize: 16,
				dataList: []
			}
		},
		created(){
			this.getDataList()
		},
		methods: {
			//获取数据列表
			async getDataList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/index/recommendCircle', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toDetail(id){
				this.$router.push({
					path: '/circleIndex?id='+id
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.title-icon{
		background: #F77D2A;
	}
	
	.aside-content ul{
		display: flex;
		flex-wrap: wrap;
		padding-top: 20px;
		overflow: hidden;
		li{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 25%;
			margin-bottom: 12px;
			cursor: pointer;
			img{
				width: 40px;
				height: 40px;
				margin-bottom: 6px;
				-webkit-mask-image: url('../../assets/board-icon-mask.svg');
				mask-image: url('../../assets/board-icon-mask.svg');
				-webkit-mask-repeat: round;
				mask-repeat: round;
			}
			span{
				line-height: 16px;
				max-width: 60px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: 12px;
			}
			
		}
	}
</style>
